import { render, staticRenderFns } from "./PageLearnerSubmission.vue?vue&type=template&id=4a9f6fdc&"
import script from "./PageLearnerSubmission.vue?vue&type=script&lang=js&"
export * from "./PageLearnerSubmission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports